var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.response)?_c('div',{staticClass:"Page Legals",attrs:{"id":"Legals"}},[_c('PrismicRichText',{attrs:{"field":_vm.response,"field-content":_vm.response}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }